module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "project-update"
  }, [_c('div', {
    staticClass: "wizard-toolbar"
  }, [_c('div', {
    staticClass: "grid-2"
  }, [_c('div', {
    staticClass: "progress-step-1 done"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project_wizard.step1-title')))])]), _vm._v(" "), _c('div', {
    staticClass: "progress-step-2 active"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project_wizard.step2-title')))])])])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('ui.project_wizard.step2-title')))]), _vm._v(" "), (_vm.planIsTalent) ? _c('form', {
    staticClass: "project-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('p', {
    staticClass: "form-subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.project_wizard.businesskits'))), _c('i', {
    staticClass: "icon icon-help-circle"
  })]), _vm._v(" "), _c('field', {
    ref: "businesskit",
    staticClass: "lead-sheet-selector",
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "rel": "businessKitId",
      "name": "business_kit_id",
      "type": "select",
      "params": {
        no_i18n: true
      },
      "collection": _vm.businessKitList
    },
    on: {
      "input": _vm.setBusinessKit
    },
    model: {
      value: (_vm.item.business_kit_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "business_kit_id", $$v)
      },
      expression: "item.business_kit_id"
    }
  }), _vm._v(" "), _c('div', {
    ref: "custom",
    staticClass: "lead-sheet-custom",
    on: {
      "click": function($event) {
        return _vm.setBusinessKit('custom')
      }
    }
  }, [_c('p', [_vm._v("\n          " + _vm._s(_vm.$t('ui.project_wizard.leadsheet-create')) + "\n        ")])])], 1) : _c('form', {
    staticClass: "project-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('p', {
    staticClass: "form-subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.project_wizard.lead-sheets'))), _c('i', {
    staticClass: "icon icon-help-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row justify-between"
  }, [_c('div', {
    ref: "basic",
    staticClass: "leadsheet-box leadsheet-basic",
    on: {
      "click": function($event) {
        return _vm.setLeadSheet('basic');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/leadsheet-standard.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Standard")])]), _vm._v(" "), _c('div', {
    ref: "advanced",
    staticClass: "leadsheet-box leadsheet-advanced",
    on: {
      "click": function($event) {
        return _vm.setLeadSheet('advanced')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/leadsheet-advanced.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Advanced")])])]), _vm._v(" "), (_vm.hasLeadMasks) ? _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('lead_masks.list'),
      expression: "'lead_masks.list'"
    }],
    ref: "leadMaskId",
    staticClass: "lead-sheet-selector",
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "lead_mask_id",
      "params": {
        no_i18n: true
      },
      "type": "select",
      "collection": _vm.leadMasks
    },
    on: {
      "input": _vm.setLeadMaskId
    },
    model: {
      value: (_vm.item.lead_mask_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "lead_mask_id", $$v)
      },
      expression: "item.lead_mask_id"
    }
  }) : _vm._e(), _vm._v(" "), (['basic', 'advanced'].includes(_vm.currentlySelected)) ? _c('div', {
    staticClass: "lead-sheet-info"
  }, [_c('p', {
    staticClass: "tip"
  }, [_c('i', {
    staticClass: "icon yule-icon-info"
  }), _vm._v(" "), (_vm.currentlySelected == 'basic') ? _c('span', [_vm._v("\n            " + _vm._s(_vm.$t('ui.project_wizard.leadsheet-basic')) + "\n          ")]) : (_vm.currentlySelected == 'advanced') ? _c('span', [_vm._v("\n            " + _vm._s(_vm.$t('ui.project_wizard.leadsheet-advanced')) + "\n          ")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "actions wizard-footer"
  }, [_c('button', {
    staticClass: "btn btn-tertiary btn-flat",
    on: {
      "click": function($event) {
        return _vm.previousStep()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.pages.previous')) + "\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.global.cancel')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-flat btn-save",
    on: {
      "click": function($event) {
        return _vm.create()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.pages.project-create-button')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed9f9ddc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/wizard/StepTwo.vue
// module id = 2010
// module chunks = 0